import { useState, useEffect, useRef } from "react";
import { adaiApi } from "../api/adaiApi.js";
import { HISTORY_DEBOUNCE_MS, HISTORY_PAGE_SIZE } from "../utils/constants.js";

export { HISTORY_PAGE_SIZE as PAGE_SIZE };

export function useHistoryData() {
  const [records, setRecords]       = useState([]);
  const [total, setTotal]           = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading]       = useState(false);
  const [search, setSearch]         = useState("");
  const [sortOrder, setSortOrder]   = useState("desc");
  const [page, setPage]             = useState(1);

  const debounceRef                       = useRef(null);
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setDebouncedSearch(search.trim());
      setPage(1);
    }, HISTORY_DEBOUNCE_MS);
    return () => clearTimeout(debounceRef.current);
  }, [search]);

  useEffect(() => { setPage(1); }, [sortOrder]);

  useEffect(() => {
    let cancelled = false;
    const fetchRecords = async () => {
      setLoading(true);
      try {
        const { data } = await adaiApi.listJobs({
          search:   debouncedSearch || undefined,
          sortOrder,
          page,
          pageSize: HISTORY_PAGE_SIZE,
        });
        if (!cancelled) {
          setRecords(data.items);
          setTotal(data.total);
          setTotalPages(data.total_pages);
        }
      } catch {
        // silently ignore — stale data shown instead
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchRecords();
    return () => { cancelled = true; };
  }, [debouncedSearch, sortOrder, page]);

  return {
    records, total, totalPages, loading,
    search, setSearch,
    sortOrder, setSortOrder,
    page, setPage,
  };
}
